import { render, staticRenderFns } from "./music.vue?vue&type=template&id=e965f472&scoped=true"
import script from "./music.vue?vue&type=script&lang=js"
export * from "./music.vue?vue&type=script&lang=js"
import style0 from "./music.vue?vue&type=style&index=0&id=e965f472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e965f472",
  null
  
)

export default component.exports